<template>
  <v-checkbox
    class="bm-checkbox"
    :input-value="value"
    :label="labelVal"
    v-bind="$attrs"
    :hide-details="hideDetails"
    :data-qa="dataQaVal"
    @change="emit('update:value', $event)"
    @focus="emit('focus')"
    @blur="emit('blur')"
  >
    <template #label>
      <slot name="label" />
    </template>
  </v-checkbox>
</template>

<script lang="ts">
export default {
  name: "BmCheckbox",
  inheritAttrs: false,
};
</script>

<script setup lang="ts">
import { useBmLabelled } from "@/components/controls/input/mixins/BmLabelled";
import type Key from "@/app/types/common/key";

interface BmCheckboxProps {
  label?: string | null;
  tooltip?: string | null;
  t?: Key;
  dataQa?: object | string;
  value?: any;
  hideDetails?: boolean;
}

interface BmCheckboxEvents {
  (event: "update:value", value: any): void;
  (event: "focus"): void;
  (event: "blur"): void;
}

const props = withDefaults(defineProps<BmCheckboxProps>(), {
  label: null,
  tooltip: null,
  hideDetails: true,
});

const emit = defineEmits<BmCheckboxEvents>();

const { labelVal, dataQaVal } = useBmLabelled(() => props);
</script>

<style lang="sass">
@import "src/sass/typography"

.bm-checkbox label.v-label
  @include bm-body

.bm-checkbox
  margin-top: 0!important
</style>
